const account = {
  delete: "Supprimer mon compte",
  deleteUser: "Supprimer le compte",
  deleteWarning:
    "Êtes-vous sûr de vouloir supprimer votre compte ? Une fois supprimé, toutes vos informations ainsi que votre abonnement ne pourront plus être récupérés.",
  deleteUserWarning:
    "Êtes-vous sûr de vouloir supprimer ce compte ? Une fois supprimé, toutes les informations ainsi que l'abonnement ne pourront plus être récupérés.",
  accountCreated:
    "Votre compte a bien été créé. Un mail vous a été envoyé pour valider votre compte (le mail peut mettre jusqu'à une minute à arriver, vérifiez dans vos courriers indésirables).",
  accessMyAccount: "Accéder à mon compte",
  myAccount: "Mon compte",
  yourAccountNotActive: "Votre compte n’est pas encore activé",
};

export default account;
